import type { DeepReadonly } from 'vue'
import {
  type PageProductVariationGiftFragment,
  type PageProductVariationGiveawayFragment,
  type PageProductVariationStrapFragment,
  type PageProductVariationToolFragment,
  type PageProductVariationWatchFragment,
} from '#graphql-operations'

export type VariationType =
  | PageProductVariationGiftFragment
  | PageProductVariationGiveawayFragment
  | PageProductVariationToolFragment
  | PageProductVariationWatchFragment
  | PageProductVariationStrapFragment

type UseCartFlyin = {
  isOpen: ComputedRef<boolean>
  open: (variation: VariationType) => void
  close: () => void
  variation: DeepReadonly<Ref<VariationType | null>>
}

export default function (): UseCartFlyin {
  const { clearMessages } = useDrupalMessages()
  const variation = useState<VariationType | null>(
    'cartFlyInVariation',
    () => null,
  )

  function open(v: VariationType) {
    clearMessages()
    variation.value = v
  }

  function close() {
    variation.value = null
  }

  const isOpen = computed(() => variation.value !== null)

  return {
    isOpen,
    open,
    close,
    variation: readonly(variation),
  }
}
